import { IItemDetail } from 'api/types/marketplace';
import { Context } from 'contexts/ContextProvider';
import { useContext } from 'react';
import { Button, Form, FormGroup, Label, Input, Row, Col } from 'reactstrap';

// Static Assets
import Frame468 from '../../../assets/images/frames/frame_456x468@2x.png';
import Title2Line from '../../../assets/images/frames/title2line@2x.png';
import PaperOutline from '../../../assets/images/icons/paper_outline@2x.png';
import ETHIcon from '../../../assets/images/icons/eth@2x.png';
import Frame468Mobile from '../../../assets/images/frames/frame_456x468_mobile@2x.png';
import Frame556 from '../../../assets/images/frames/frame_456x556@2x.png';
import Frame556Mobile from '../../../assets/images/frames/frame_456x556_mobile@2x.png';

interface Props {
  itemDetailObj: IItemDetail;
  itemRequestHandler: () => void;
  itemRequestLoader: boolean;
  approveTokenHandler: () => void;
  approveTokenLoader: boolean;
  isTokenApproved: boolean;
  setQuantity: (val: string) => void;
  quantity: string;
}

const BuyForm = ({
  itemRequestHandler,
  itemRequestLoader,
  itemDetailObj,
  approveTokenHandler,
  isTokenApproved,
  approveTokenLoader,
  setQuantity,
  quantity,
}: Props) => {
  const { walletAddress, showLoader, connectWalletHandler } = useContext(Context);

  return (
    <div className={`frame-${walletAddress && itemDetailObj.sellType === 'raffle' ? `644` : `456`}`}>
      <img
        src={walletAddress && itemDetailObj.sellType === 'raffle' ? Frame556 : Frame468}
        alt="Frame556"
        className="img-fluid desktop-visible"
      />
      <img
        src={walletAddress && itemDetailObj.sellType === 'raffle' ? Frame556Mobile : Frame468Mobile}
        alt="Frame556Mobile"
        className="img-fluid mobile-visible"
      />
      <div className={`frame-${walletAddress && itemDetailObj.sellType === 'raffle' ? `644` : `456`}-wrap`}>
        <div className="title-wrap">
          <img src={Title2Line} alt="Title2Line" className="img-fluid" />
          <h2 className={`title-text`}>{itemDetailObj.title}</h2>
        </div>
        <div className={`frame-${walletAddress && itemDetailObj.sellType === 'raffle' ? `644` : `456`}-content`}>
          <Form name="" className={`form-horizontal`}>
            <FormGroup className={`form-group`}>
              <Label for="Type">Type</Label>
              <Input
                id="Type"
                name="Type"
                placeholder=""
                type="text"
                value={itemDetailObj.type}
                className=""
                disabled
              />
            </FormGroup>

            <FormGroup className={`form-group`}>
              <Label for="priceOfItem">PRICE OF ITEM</Label>
              <Row className="less-gutters">
                {itemDetailObj.buyPriceEth ? (
                  <Col
                    md={itemDetailObj.buyPricePaper ? 6 : 12}
                    className={`${itemDetailObj.buyPricePaper ? `sm:col-half` : ``}`}
                  >
                    <div className="form-control-icon disabled">
                      <span className="icon-16">
                        <img src={ETHIcon} alt="ETH" className="img-fluid" />
                      </span>
                      <Input
                        id="priceOfItem"
                        name="priceOfItem"
                        placeholder=""
                        type="text"
                        className={`${itemDetailObj.buyPricePaper ? `small` : ``}`}
                        value={itemDetailObj.buyPriceEth}
                        disabled
                      />
                    </div>
                  </Col>
                ) : null}

                {itemDetailObj.buyPricePaper ? (
                  <Col
                    md={itemDetailObj.buyPriceEth ? 6 : 12}
                    className={`${itemDetailObj.buyPriceEth ? `sm:col-half` : ``}`}
                  >
                    <div className="form-control-icon disabled">
                      <span className="icon-16">
                        <img src={PaperOutline} alt="Paper Outline" className="img-fluid" />
                      </span>
                      <Input
                        id="priceOfItem"
                        name="priceOfItem"
                        placeholder=""
                        type="text"
                        className={`${itemDetailObj.buyPriceEth ? `small` : ``}`}
                        value={itemDetailObj.buyPricePaper}
                        disabled
                      />
                    </div>
                  </Col>
                ) : null}
              </Row>
            </FormGroup>

            {itemDetailObj.sellType === 'buy' && (
              <FormGroup className={`form-group mb-3`}>
                <Label for="RedeemsAvailable">REDEEMS AVAILABLE</Label>
                <Input
                  id="RedeemsAvailable"
                  name="RedeemsAvailable"
                  placeholder=""
                  type="text"
                  value={
                    itemDetailObj.quantity - itemDetailObj.soldQuantity > 0
                      ? itemDetailObj.quantity - itemDetailObj.soldQuantity
                      : 0
                  }
                  disabled
                />
              </FormGroup>
            )}

            {itemDetailObj.sellType === 'raffle' && walletAddress && (
              <FormGroup className={`form-group`}>
                <Row className="less-gutters">
                  <Col md={6} className="sm:col-half">
                    <Label for="ticketBought">TICKETS BOUGHT</Label>
                    <Input
                      id="ticketBought"
                      name="ticketBought"
                      placeholder=""
                      type="text"
                      value={itemDetailObj.ticketBought}
                      className="small"
                      disabled
                    />
                  </Col>
                  <Col md={6} className="sm:col-half">
                    <Label for="ticketsSold">TICKETS SOLD</Label>
                    <Input
                      id="ticketsSold"
                      name="ticketsSold"
                      placeholder=""
                      type="text"
                      value={itemDetailObj.ticketsSold}
                      className="small"
                      disabled
                    />
                  </Col>
                </Row>
              </FormGroup>
            )}

            {itemDetailObj.sellType === 'raffle' && (
              <FormGroup className={`form-group mb-3`}>
                <Label for="raffleQuantity">QUANTITY</Label>
                <Input
                  id="raffleQuantity"
                  name="raffleQuantity"
                  placeholder="ENTER QUANTITY..."
                  type="text"
                  value={quantity}
                  onChange={(e) => setQuantity(e.target.value)}
                  className=""
                  autoComplete="off"
                  disabled={walletAddress ? false : true}
                />
              </FormGroup>
            )}

            {(walletAddress && isTokenApproved) ||
            (itemDetailObj.sellType === 'buy' && itemDetailObj.soldQuantity >= itemDetailObj.quantity) ? (
              <Button
                block
                className={`button-bid${itemRequestLoader ? ` is-loading` : ``}`}
                onClick={walletAddress && isTokenApproved ? itemRequestHandler : () => {}}
                disabled={
                  !itemDetailObj.isActive ||
                  (itemDetailObj.sellType === 'buy' && itemDetailObj.soldQuantity >= itemDetailObj.quantity)
                    ? true
                    : false
                }
              >
                {itemDetailObj.sellType === 'buy' && itemDetailObj.soldQuantity >= itemDetailObj.quantity
                  ? `SOLD OUT`
                  : !itemDetailObj.isActive
                  ? 'SALE CLOSED'
                  : `BUY NOW`}
              </Button>
            ) : null}

            {(!walletAddress && itemDetailObj.sellType === 'raffle') ||
            (!walletAddress &&
              itemDetailObj.sellType === 'buy' &&
              itemDetailObj.soldQuantity < itemDetailObj.quantity) ? (
              <Button
                block
                className={`button-bid${showLoader ? ` is-loading` : ``}`}
                onClick={() => connectWalletHandler()}
              >
                CONNECT WALLET
              </Button>
            ) : null}

            {(walletAddress && !isTokenApproved && itemDetailObj.sellType === 'raffle') ||
            (walletAddress &&
              !isTokenApproved &&
              itemDetailObj.sellType === 'buy' &&
              itemDetailObj.soldQuantity < itemDetailObj.quantity) ? (
              <Button
                block
                className={`button-bid${approveTokenLoader ? ` is-loading` : ``}`}
                onClick={approveTokenHandler}
              >
                APPROVE
              </Button>
            ) : null}
          </Form>
        </div>
      </div>
    </div>
  );
};

export default BuyForm;
